import { createTheme, Theme } from "@mui/material/styles";
import Druk from "../../fonts/Druk-Medium.woff";

const formLabelComponent = {
  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        fontSize: theme.typography.body1.fontSize,
      }),
    },
  },
};

const button = {
  MuiButton: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      textPrimary: {
        color: "#000000",
        "&:hover": {
          color: "#00db8f",
        },
      },
      root: {
        fontFamily: ["Inter", "Helvetica Neue", "sans-serif"].join(", "),
      },
    },
  },
};

const selectComponent = {
  MuiFormControl: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        '&[data-validation-severity="warning"]': {
          "& .MuiInputLabel-root": {
            color: theme.palette.warning.main,
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: theme.palette.warning.main,
          },
          "& .MuiInputLabel-root.Mui-error": {
            color: theme.palette.warning.main,
          },
          "& .MuiInput-root": {
            color: theme.palette.warning.main,
          },
          "& .MuiInput-root:before": {
            borderBottomColor: theme.palette.warning.main,
          },
          "& .MuiInput-root:hover:not(.Mui-disabled):before": {
            borderBottomColor: theme.palette.warning.main,
          },
          "& .MuiInput-root:after": {
            borderBottomColor: theme.palette.warning.main,
          },
          "& .MuiInput-root.Mui-error:before": {
            borderBottomColor: theme.palette.warning.main,
          },
          "& .MuiInput-root.Mui-error:after": {
            borderBottomColor: theme.palette.warning.main,
          },
          "& .MuiSelect-select": {
            color: theme.palette.warning.main,
          },
          "& .MuiSelect-icon": {
            color: theme.palette.warning.main,
          },
          "& .MuiFormHelperText-root": {
            color: theme.palette.warning.main,
          },
          "& .MuiFormHelperText-root.Mui-error": {
            color: theme.palette.warning.main,
          },
          "& .MuiInput-root.MuiInput-underline.Mui-error::before": {
            borderBottomColor: theme.palette.warning.main,
          },
          "& .MuiInput-root.MuiInput-underline.Mui-error:hover::before": {
            borderBottomColor: theme.palette.warning.main,
          },
          "& .MuiInput-root.MuiInput-underline.Mui-error::after": {
            borderBottomColor: theme.palette.warning.main,
          },
        },
      }),
    },
  },
};

const cssBaseline = {
  MuiCssBaseline: {
    styleOverrides: `
        @font-face {
          font-family: 'Inter';
          font-style: normal;
          }
          @font-face {
            font-family: 'Druk';
            font-style: normal;
            src: local('Druk'), url(${Druk}) format('woff');
        }
      `,
  },
};

const typography = {
  fontFamily: "Inter",
  druk: { fontFamily: "Druk, sans-serif" },
};

const palette = {
  primary: {
    main: "#000000",
  },
  secondary: {
    main: "#00db8f",
  },
  error: {
    main: "#d32f2f",
  },
  warning: {
    main: "#ff8800",
  },
  background: {
    default: "#ffffff",
    tabCard: "#f7f7f7",
    overlay: "rgba(0, 0, 0, 0.87)",
    banner: "#0d2a1c",
  },
  brand: {
    earthly: "#40e4ab",
    earthlyLight: "#9ff1d5",
    sand: "#D9CA80",
    sun: "#E35E40",
    sun50: "#eba899",
    carbon: "#797979",
    sea: "#3062C0",
    sea50: "#91aad9",
    sky: "#76BEC6",
    plain: "#ffffff",
    treePlanting: "#ece4bf",
    biodiversityCredits: "#badee2",
    carbonCredits: "#9ff1d5",
    marine: "#98B1DF",
  },
  incident: {
    deforestation: "#2e9a2e",
    earthquake: "#892806",
    tsunami: "#fcf7f7",
  },
  map: {
    interaction: "#ffd600",
  },
  pillars: {
    carbon: {
      light: "#cdcdcd",
      dark: "#797979",
    },
    biodiversity: {
      light: "#b9f0dd",
      dark: "#40e4aa",
    },
    people: {
      light: "#f1b09f",
      dark: "#e45e40",
    },
  },
};

export const globalStyles = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 360,
      md: 768,
      lg: 1024,
      xl: 1366,
    },
  },
  components: {
    ...formLabelComponent,
    ...selectComponent,
    ...button,
    ...cssBaseline,
  },
  typography,
  palette,
});
